module.exports = __webpack_public_path__ + "img/actionstep.04d2acff.png";